import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e759d72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-row" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icons/dca-logo.svg",
  alt: "DCA Logo",
  class: "logo-icon"
}, null, -1))
const _hoisted_4 = { class: "main-nav" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L6 6L11 1",
    stroke: "currentColor",
    "stroke-width": "1.5",
    fill: "none"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L6 6L11 1",
    stroke: "currentColor",
    "stroke-width": "1.5",
    fill: "none"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-cta" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "cta-button" }, "Request a Proposal")
], -1))
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "mega-menu__inner" }
const _hoisted_14 = { class: "mega-menu__links" }
const _hoisted_15 = { class: "mega-menu__item-title" }
const _hoisted_16 = { class: "mega-menu__item-description" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mega-menu__eyebrow" }, "Featured Work", -1))
const _hoisted_18 = {
  href: "#",
  class: "mega-menu__project"
}
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "mega-menu__project-title" }
const _hoisted_21 = { class: "mega-menu__project-client" }
const _hoisted_22 = { class: "mega-menu__project-type" }
const _hoisted_23 = { class: "mobile-menu__body" }
const _hoisted_24 = { class: "mobile-menu__nav" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "mobile-menu__link"
}, "Our work", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "14",
  viewBox: "0 0 12 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.24264 3.18856L8.48528 7.4312L4.24264 11.6738",
    stroke: "black",
    "stroke-width": "1.8"
  })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "14",
  viewBox: "0 0 12 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.24264 3.18856L8.48528 7.4312L4.24264 11.6738",
    stroke: "black",
    "stroke-width": "1.8"
  })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "mobile-menu__link"
}, "Who we are", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "mobile-menu__link"
}, "Insights", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-menu__cta" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "mobile-menu__cta-button" }, "Request a Proposal")
], -1))
const _hoisted_31 = { class: "mobile-menu__submenu-header" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "14",
  viewBox: "0 0 12 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.75736 10.2426L3.51472 6L7.75736 1.75736",
    stroke: "black",
    "stroke-width": "1.8"
  })
], -1))
const _hoisted_33 = { class: "mobile-menu__submenu-content" }
const _hoisted_34 = { class: "mobile-menu__submenu-featured" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mobile-menu__submenu-eyebrow" }, "FEATURED WORK", -1))
const _hoisted_36 = {
  href: "#",
  class: "mobile-menu__submenu-project"
}
const _hoisted_37 = ["src", "alt"]
const _hoisted_38 = { class: "mobile-menu__submenu-project-info" }
const _hoisted_39 = { class: "mobile-menu__submenu-project-title" }
const _hoisted_40 = { class: "mobile-menu__submenu-project-client" }
const _hoisted_41 = { class: "mobile-menu__submenu-project-type" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-menu__cta" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "mobile-menu__cta-button" }, "Request a Proposal")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_CustomCursor = _resolveComponent("CustomCursor")!
  const _component_ClippingAnimation = _resolveComponent("ClippingAnimation")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header-new", { 'header-hidden': _ctx.isHeaderHidden }]),
    onMouseleave: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeMegaMenu && _ctx.closeMegaMenu(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["mega-menu-backdrop", { 'mega-menu-backdrop--visible': _ctx.activeMegaMenu || _ctx.isMobileMenuOpen }])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["header-content", { 'header-content--menu-open': _ctx.activeMegaMenu || _ctx.isMobileMenuOpen }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_RouterLink, {
            to: { name: _ctx.Route.Home }
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("a", {
            href: "#",
            class: "nav-link",
            onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeMegaMenu && _ctx.closeMegaMenu(...args)))
          }, "Our work", 32),
          _createElementVNode("div", {
            class: _normalizeClass(["nav-item nav-item--has-menu", { 'nav-item--active': _ctx.activeMegaMenu === 'solutions' }]),
            onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openMegaMenu('solutions'))),
            onFocusin: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openMegaMenu('solutions')))
          }, [
            _createElementVNode("a", {
              href: "#",
              class: "nav-link dropdown",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createTextVNode(" Solutions "),
              _hoisted_5
            ])
          ], 34),
          _createElementVNode("div", {
            class: _normalizeClass(["nav-item nav-item--has-menu", { 'nav-item--active': _ctx.activeMegaMenu === 'capabilities' }]),
            onMouseenter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openMegaMenu('capabilities'))),
            onFocusin: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openMegaMenu('capabilities')))
          }, [
            _createElementVNode("a", {
              href: "#",
              class: "nav-link dropdown",
              onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createTextVNode(" Capabilities "),
              _hoisted_6
            ])
          ], 34),
          _createElementVNode("a", {
            href: "#",
            class: "nav-link",
            onMouseenter: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeMegaMenu && _ctx.closeMegaMenu(...args)))
          }, "Who we are", 32),
          _createElementVNode("a", {
            href: "#",
            class: "nav-link",
            onMouseenter: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeMegaMenu && _ctx.closeMegaMenu(...args)))
          }, "Insights", 32)
        ]),
        _hoisted_7,
        _createElementVNode("button", {
          class: _normalizeClass(["mobile-menu-button", { 'mobile-menu-button--open': _ctx.isMobileMenuOpen }]),
          "aria-label": _ctx.isMobileMenuOpen ? 'Close menu' : 'Open menu',
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileMenu && _ctx.toggleMobileMenu(...args)))
        }, _hoisted_12, 10, _hoisted_8)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["mega-menu", {
                    'mega-menu--visible': _ctx.activeMegaMenu,
                    'mega-menu--revealed': _ctx.isMegaMenuRevealed
                }]),
        onMouseleave: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeMegaMenu && _ctx.closeMegaMenu(...args)))
      }, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeMegaMenuItems, (item, index) => {
              return (_openBlock(), _createBlock(_component_CustomCursor, {
                key: item.title,
                text: "View",
                "is-dark": ""
              }, {
                default: _withCtx(({ eventListeners }) => [
                  _createElementVNode("a", _mergeProps({
                    href: "#",
                    class: "mega-menu__item mega-menu__reveal-item",
                    style: { '--reveal-delay': `${index * 40}ms` }
                  }, eventListeners), [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(item.title), 1),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(item.description), 1)
                  ], 16)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _createVNode(_component_CustomCursor, {
            text: "View",
            "is-dark": ""
          }, {
            default: _withCtx(({ eventListeners }) => [
              _createElementVNode("div", _mergeProps({
                class: "mega-menu__featured mega-menu__reveal-item",
                style: {"--reveal-delay":"240ms"}
              }, eventListeners), [
                _hoisted_17,
                _createElementVNode("a", _hoisted_18, [
                  _createVNode(_component_ClippingAnimation, { interactive: "" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _ctx.activeMegaMenuProject.image,
                        alt: _ctx.activeMegaMenuProject.title,
                        class: "mega-menu__project-image"
                      }, null, 8, _hoisted_19)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.activeMegaMenuProject.title), 1),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.activeMegaMenuProject.client), 1),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.activeMegaMenuProject.type), 1)
                ])
              ], 16)
            ]),
            _: 1
          })
        ])
      ], 34),
      _createElementVNode("div", {
        class: _normalizeClass(["mobile-menu", { 'mobile-menu--open': _ctx.isMobileMenuOpen }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["mobile-menu__panel", { 'mobile-menu__panel--submenu': _ctx.activeMobileSubmenu }])
        }, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", {
              class: _normalizeClass(["mobile-menu__main", { 'mobile-menu__main--hidden': _ctx.activeMobileSubmenu }])
            }, [
              _createElementVNode("nav", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("button", {
                  class: "mobile-menu__link mobile-menu__link--dropdown",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openMobileSubmenu('solutions')))
                }, [
                  _createTextVNode(" Solutions "),
                  _hoisted_26
                ]),
                _createElementVNode("button", {
                  class: "mobile-menu__link mobile-menu__link--dropdown",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openMobileSubmenu('capabilities')))
                }, [
                  _createTextVNode(" Capabilities "),
                  _hoisted_27
                ]),
                _hoisted_28,
                _hoisted_29
              ]),
              _hoisted_30
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["mobile-menu__submenu", { 'mobile-menu__submenu--open': _ctx.activeMobileSubmenu }])
            }, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  class: "mobile-menu__back",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeMobileSubmenu && _ctx.closeMobileSubmenu(...args)))
                }, [
                  _hoisted_32,
                  _createTextVNode(" Back ")
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeMobileSubmenuItems, (item) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: item.title,
                    href: "#",
                    class: "mobile-menu__submenu-item"
                  }, _toDisplayString(item.title), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("a", _hoisted_36, [
                  _createElementVNode("img", {
                    src: _ctx.activeMobileSubmenuProject.image,
                    alt: _ctx.activeMobileSubmenuProject.title
                  }, null, 8, _hoisted_37),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.activeMobileSubmenuProject.title), 1),
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.activeMobileSubmenuProject.client), 1),
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.activeMobileSubmenuProject.type), 1)
                  ])
                ])
              ]),
              _hoisted_42
            ], 2)
          ])
        ], 2)
      ], 2)
    ], 2)
  ], 34))
}